class DynamicYouTubeVideo {
  constructor(section) {
      this.$el = section.el;
      this.$window = $(window);
      this.flickity = null;
      this.events = new EventHandler/* default */.Z();
      this.carousel = this.$el.querySelector('.youtube-video-content');
      this.slides = this.$el.querySelectorAll('.youtube-video-item');

      this.onBreakpointChange = () => {
          if (cjs.max('XS') && this.slides.length > 1 || cjs.max('L') && this.slides.length >= 3 || cjs.min('XL') && this.slides.length > 3) {
              this._initFlickity();
          } else {
              this._destroyFlickity();
          }
      };

      this.onBreakpointChange();
      cjs.onChange(this.onBreakpointChange);
  }

  onSectionUnload() {
      this._destroyFlickity();

      cjs.offChange(this.onBreakpointChange);
      this.events.unregisterAll();
  }

  _initFlickity() {
      if (this.Flickity) {
          return;
      }

      this.flickity = new (js_default())(this.carousel, {
          autoPlay: 0,
          accessibility: true,
          cellAlign: 'left',
          cellSelector: '.youtube-video-item',
          groupCells: true,
          pageDots: true,
          contain: true,
          adaptiveHeight: false,
          arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
      });
      this.events.register(this.carousel, 'rimg:load', () => {
          this.flickity.resize();
      });
  }

  _destroyFlickity() {
      if (!this.flickity) {
          return;
      }

      this.flickity.destroy();
      this.flickity = null;
  }
}

sections.register('dynamic-youtube-video-section', section => new DynamicYouTubeVideo(section), {
  lazy: true
});